'use strict';

var hasSymbols = require('has-symbols/shams');

module.exports = function hasToStringTagShams() {
	return hasSymbols() && !!Symbol.toStringTag;
};



// WEBPACK FOOTER //
// webpack://pdfmake/node_modules/has-tostringtag/shams.js